/*burdanbi@gmail.com
 https://www.burdanbi.xyz/login/google/callback
*/
export const Config = {
    googleOAuthClientId:'723237821154-a9cgh9285m447i8d4i4o31svoscondo4.apps.googleusercontent.com',
    apiHost: 'https://site.burdanbi.xyz:32103/'
}